import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { getAccessToken } from '@/api';

interface RequireAuthProps {
  children: React.ReactNode;
}

export default function RequireAuth({ children }: RequireAuthProps) {
  const location = useLocation();
  const { authenticated, refreshProfile } = useAuthStore();
  const hasToken = !!getAccessToken();

  useEffect(() => {
    if (!hasToken) return;
    // 有 token 时始终拉取最新 profile（含钱包余额），避免 persist 缓存导致顶部余额过期
    refreshProfile().catch(() => {
      /* 拦截器已统一提示并跳转 login */
    });
  }, [hasToken, refreshProfile]);

  if (!hasToken && !authenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
